<footer class="footer -type-1">
  <div class="container">
      <div class="pt-60 pb-60">
        <div class="row y-gap-40 justify-between xl:justify-start">
          <div class="col-xl-2 col-lg-4 col-sm-6">
            <h5 class="text-16 fw-500 mb-30">Kurumsal</h5>
            <div class="d-flex y-gap-10 flex-column">
              <a routerLink="/about">Hakkımızda</a>
              <a routerLink="/blog">Blog</a>
              <a routerLink="/contact">İletişim</a>
              <a routerLink="/help-center">Yardım Merkezi</a>
              <a routerLink="/gizlilik-politikasi">Gizlilik Politikası</a>
              <a routerLink="/kullanim-kosullari">Kullanım Koşulları</a>
              <a routerLink="/mesafeli-satis-sozlesmesi">Mesafeli Satış</a>
              <a routerLink="/iptal-iade-politikasi">İptal ve İade</a>
            </div>
          </div>

          <div class="col-xl-2 col-lg-4 col-sm-6">
            <h5 class="text-16 fw-500 mb-30">İletişim Bilgilerimiz</h5>

            <div class="mt-30">
              <div class="text-14 mt-30">Müşteri Hizmetleri</div>
              <a href="tel:+902422120224" class="text-18 fw-500  mt-5">0242 212 02 24</a>
            </div>

            <div class="mt-35">
              <div class="text-14 mt-30">E-posta Desteği</div>
              <a href="mailto:info@pusulatatil.com" class="text-18 fw-500 mt-5">destek&#64;pusulatatil.com</a>
            </div>
          </div>

          <div class="col-xl-3 col-lg-4 col-sm-6">
            <h5 class="text-16 fw-500 mb-30">Adres</h5>
            <div class="text-14 lh-18">
              <i class="icon-location text-16 mr-10"></i>
              Varlık, Piri Reis Cd. No:38<br>
              07230 Muratpaşa/Antalya
            </div>
          </div>

          <div class="col-xl-2 col-lg-4 col-sm-6">
            <h5 class="text-16 fw-500 mb-30">TÜRSAB NO: 17304</h5>
            <a href="https://www.tursab.org.tr/tr/ddsv" target="_blank" class="tursab-badge">
              <img src="assets/img/tursab-dds-17304.png" alt="TÜRSAB Dijital Doğrulama Sistemi - Belge No: 17304" class="tursab-badge-img" />
            </a>
          </div>
        </div>
      </div>

      <div class="py-20 border-top-light">
        <div class="row justify-between items-center y-gap-10">
          <div class="col-auto">
            <div class="d-flex items-center text-light-1">
              © 2026 Pusula Tatil. Tüm hakları saklıdır.
            </div>
          </div>

          <div class="col-auto">
            <div class="text-12 text-light-1 text-center">Hİ TRAVEL TURİZM İTHALAT İHRACAT SANAYİ VE TİCARET LİMİTED ŞİRKETİ</div>
          </div>

          <div class="col-auto">
            <img src="assets/pusula/logo_band_colored.svg" alt="Ödeme Yöntemleri" style="height: 32px;" />
          </div>
        </div>
      </div>
    </div>
  </footer>